import { Module } from 'vuex';
import { AdventuresState } from './types';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const adventures: Module<AdventuresState, any> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default adventures;
